import { useMemo } from 'react';
import useTrackingCore from './core';
import { useAddOns, useMsci, usePayment, useSummary } from '@/store';

export default function use3DsTracking() {
  const {
    ticketInsurance: { selected },
  } = useAddOns();

  const {
    msci: { selected: planSelected, bin },
  } = useMsci();

  const { trackEventWithCouponValueAndTimeRemaining, trackEvent } =
    useTrackingCore();

  const { attemptsCount } = usePayment();

  const threeDsTrackingFunctions = useMemo(() => {
    return {
      with3Ds: (trackFn) => {
        return (eventName, data) => {
          trackFn(eventName, {
            ...data,
            purchase_type: 'paid', // get this value from hooks
            payment_method: 'card', // this one too
            ticket_protection: selected,
            bin,
            ...(planSelected ? { installmentPlan: planSelected } : {}),
          });
        };
      },
      withAttemps: (trackFn) => {
        return (eventName, data) => {
          trackFn(eventName, {
            ...data,
            attempts: attemptsCount,
          });
        };
      },
      trackEventWith3Ds: (eventName, data) =>
        threeDsTrackingFunctions.with3Ds((eventName, data) =>
          trackEventWithCouponValueAndTimeRemaining(eventName, data),
        )(eventName, data),
      trackEventWith3DsAndAttempts: (eventName, data) =>
        threeDsTrackingFunctions.withAttemps((eventName, data) =>
          threeDsTrackingFunctions.trackEventWith3Ds(eventName, data),
        )(eventName, data),
      flowStarted: () => {
        threeDsTrackingFunctions.trackEventWith3Ds('3ds_flow_started', {});
      },
      redirectInitiated: () => {
        threeDsTrackingFunctions.trackEventWith3DsAndAttempts(
          '3Ds_redirect_initiated',
          {},
        );
      },
      returnedFromBank: () => {
        threeDsTrackingFunctions.trackEventWith3DsAndAttempts(
          '3Ds_returned_from_bank',
          {},
        );
      },

      challengeFailed: ({ reason }) => {
        threeDsTrackingFunctions.trackEventWith3DsAndAttempts(
          '3Ds_challenge_failed',
          {
            failure_reason: reason || 'unknown',
          },
        );
      },
      challengeSuccess: () => {
        threeDsTrackingFunctions.trackEventWith3DsAndAttempts(
          '3Ds_challenge_success',
          {},
        );
      },
      monitor: (data) => {
        trackEvent('3Ds_verification_error_viewed', { ...data });
      },
    };
  }, [
    bin,
    planSelected,
    selected,
    trackEventWithCouponValueAndTimeRemaining,
    attemptsCount,
    trackEvent,
  ]);

  return threeDsTrackingFunctions;
}
